import React, { Fragment } from 'react';
import Box from 'components/atoms/Box/Box';
import Typography from 'components/atoms/Typography/Typography';

import IconButton from 'components/molecules/IconButton/IconButton';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';

import {
  IconArrowLeft,
  IconArrowLeftSecondary,
  IconArrowRight,
  IconArrowRightSecondary,
} from 'assets/iconsList';
import { useSectionNavigationStyles } from './sectionNavigationStyles';

export default function SectionNavigation(props) {
  const { title, icon, onClickPrevious, onClickNext } = props;
  const classes = useSectionNavigationStyles(props);
  const rtlDirection = window.localStorage.getItem('lan_dir_xh');

  const getLeftIcon = () => {
    if (rtlDirection === 'rtl') {
      return props.secondary ? IconArrowRightSecondary : IconArrowRight;
    } else {
      return props.secondary ? IconArrowLeftSecondary : IconArrowLeft;
    }
  };

  const getRightIcon = () => {
    if (rtlDirection === 'rtl') {
      return props.secondary ? IconArrowLeftSecondary : IconArrowLeft;
    } else {
      return props.secondary ? IconArrowRightSecondary : IconArrowRight;
    }
  };

  return (
    <Fragment>
      <Box
        width={{ xs: '100%', sm: '100%', md: '80%', lg: '80%' }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <IconButton onButtonClick={onClickPrevious}>
            <SvgIcon
              width={{ xs: '12px', sm: '14px', md: '15px', lg: '19px' }}
              icon={getLeftIcon()}
            ></SvgIcon>
          </IconButton>
        </Box>
        <Box className={classes.box} mr={{ lg: '4rem', md: '4rem' }}>
          {icon && (
            <SvgIcon
              width={{ xs: '41px', sm: '41px', md: '57px', lg: '72px' }}
              icon={icon}
            ></SvgIcon>
          )}
          <Typography variant="h1" className={classes.text}>
            {title}
          </Typography>
        </Box>
        <IconButton onButtonClick={onClickNext}>
          <SvgIcon
            width={{ xs: '12px', sm: '14px', md: '15px', lg: '19px' }}
            icon={getRightIcon()}
          ></SvgIcon>
        </IconButton>
      </Box>
    </Fragment>
  );
}
